"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _giftAway = require("@/api/gift-away");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../customer/CustomerTable.vue");
var _GiveawayExcelTable = _interopRequireDefault(require("./components/GiveawayExcelTable.vue"));
var _FilterOrder = _interopRequireDefault(require("./components/FilterOrder.vue"));
var _GiveAwayModal = _interopRequireDefault(require("./components/GiveAwayModal.vue"));
var _giveawayExcel = require("./components/giveaway-excel");
var _SelectDateModal = _interopRequireDefault(require("../../components/Shared/SelectDateModal.vue"));
var _moment = _interopRequireDefault(require("moment"));
var GiveawayTable = /*#__PURE__*/function (_Vue) {
  function GiveawayTable() {
    var _this;
    (0, _classCallCheck2.default)(this, GiveawayTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, GiveawayTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "giveAways", []);
    (0, _defineProperty2.default)(_this, "giveawaysExport", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      type: ""
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", _CustomerTable.groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "exportType", "real");
    return _this;
  }
  (0, _inherits2.default)(GiveawayTable, _Vue);
  return (0, _createClass2.default)(GiveawayTable, [{
    key: "transformGiveAways",
    get: function get() {
      var data = [];
      data = this.giveAways.map(function (giveAway) {
        var total = 0;
        giveAway.giveawayDetails.forEach(function (giveawayDetail) {
          total += giveawayDetail.quantity;
        });
        giveAway.totalQuantity = total;
        return giveAway;
      });
      return data;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.query.type = this.type;
      if (this.$route.query.orderCode) {
        this.query.search = this.$route.query.orderCode;
      }
      this.fetchOrders();
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchOrders();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "fetchOrders",
    value: function fetchOrders() {
      var _this2 = this;
      this.loading = true;
      _giftAway.giveAwayApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters)).then(function (res) {
        _this2.giveAways = res.data.giveaways;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "fetchGiveawayExport",
    value: function () {
      var _fetchGiveawayExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var extendQuery,
          query,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              extendQuery = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters), extendQuery);
              delete query.page;
              delete query.limit;
              _context.next = 6;
              return _giftAway.giveAwayApi.findAll(query);
            case 6:
              res = _context.sent;
              this.giveawaysExport = res.data.giveaways;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchGiveawayExport() {
        return _fetchGiveawayExport.apply(this, arguments);
      }
      return fetchGiveawayExport;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.modal.handleCreate();
    }
  }, {
    key: "exportExcel",
    value: function () {
      var _exportExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(type, _ref) {
        var from, to;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              from = _ref.from, to = _ref.to;
              this.loadingExcel = true;
              _context2.next = 4;
              return this.fetchGiveawayExport({
                from: from,
                to: to
              });
            case 4:
              this.loadingExcel = false;
              (0, _giveawayExcel.exportGiveawayExcel)({
                data: this.giveawaysExport,
                type: type,
                fromDate: (0, _moment.default)(from).format("DD/MM/YYYY"),
                toDate: (0, _moment.default)(to).format("DD/MM/YYYY")
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function exportExcel(_x, _x2) {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }()
  }, {
    key: "handleExportExcel",
    value: function handleExportExcel(exportType) {
      this.exportType = exportType;
      this.$refs.SelectDateModal.handleCreate();
    }
  }, {
    key: "handleSelectDateOk",
    value: function handleSelectDateOk(_ref2) {
      var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
      switch (this.exportType) {
        case "real":
          this.exportExcelReal({
            from: startDate,
            to: endDate
          });
          break;
        case "accountant":
          this.exportExcelAccountant({
            from: startDate,
            to: endDate
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: "exportExcelReal",
    value: function exportExcelReal(_ref3) {
      var from = _ref3.from,
        to = _ref3.to;
      this.exportExcel("real", {
        from: from,
        to: to
      });
    }
  }, {
    key: "exportExcelAccountant",
    value: function exportExcelAccountant(_ref4) {
      var from = _ref4.from,
        to = _ref4.to;
      this.exportExcel("accountant", {
        from: from,
        to: to
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], GiveawayTable.prototype, "type", void 0);
GiveawayTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    GiveAwayModal: _GiveAwayModal.default,
    FilterOrder: _FilterOrder.default,
    GiveawayExcelTable: _GiveawayExcelTable.default,
    SelectDateModal: _SelectDateModal.default
  }
})], GiveawayTable);
var _default = exports.default = GiveawayTable;